import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SubjectTestsRoutingModule } from './subject-tests-routing.module';
import { SubjectTestListComponent } from './subject-test-list/subject-test-list.component';
import { SubjectTestComponent } from './subject-test/subject-test.component';
import { SubjectListComponent } from './subject-list/subject-list.component';
import { SubjectTestPermissionComponent } from './subject-test-permission/subject-test-permission.component';


@NgModule({
  declarations: [SubjectTestListComponent, SubjectTestComponent, SubjectListComponent, SubjectTestPermissionComponent],
  imports: [
    CommonModule,
    SubjectTestsRoutingModule
  ]
})
export class SubjectTestsModule { }
